export const changeLevel4NameReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_LEVEL4DATA_NAME":
      return action.payload.level4Data;
    default:
      return state;
  }
};
